import { request } from "../../utils/request.js";
import { locationRestJobGet } from "../../wp-api/job.get.js";
/**
 * Fetch job by id. Additionally, you can set a `lock` boolean so other tabs could
 * not process this job furthermore. This is useful for client jobs.
 */ async function fetchJob(id, lock) {
    return await request({
        location: locationRestJobGet,
        params: {
            id,
            lock
        }
    });
}
export { fetchJob };
